export const questions = [
  {
    title: 'Язык JavaScript является подвидом языка Java – верно ?',
    variants: ['да', 'нет', 'наоборот, Java – подвид JavaScript'],
    correct: 1,
  },
  {
    title: 'Какие из этих вариантов задают массив из элементов «a», «b»?',
    variants: [
      'let a = { "a", "b" }',
      'let a = ( "a", "b" )',
      'let a = "a,b".split(",")',
    ],
    correct: 2,
  },
  {
    title: 'Что делает оператор === ?',
    variants: [
      'сравнивает по ссылке, а не по значению.',
      'сравнивает без приведения типа',
      'нет такого оператора',
    ],
    correct: 1,
  },
  {
    title: 'Верно ли, что null == undefined ?',
    variants: ['да', 'нет'],
    correct: 0,
  },
  {
    title: 'Какие конструкции для циклов есть в javascript ?',
    variants: [
      'Только две: for и while',
      'Только одна: for',
      'Три: for, while и do...while',
    ],
    correct: 2,
  },
  {
    title: 'Какая арифметическая операция приводит к ошибке в javascript?',
    variants: [
      'Деление на ноль',
      'Умножение числа на строку',
      'Корень из отрицательного числа',
      'Никакая из вышеперечисленных',
    ],
    correct: 3,
  },
  {
    title: 'Что получится, если сложить true + false ?',
    variants: ['truefalse', '0', '1', 'NaN'],
    correct: 2,
  },
  {
    title: 'Что такое ECMAScript ?',
    variants: [
      'Новый язык программирования',
      'Переработанная реализация Javascript',
      'Спецификация языка Javascript',
    ],
    correct: 2,
  },
  {
    title: 'React - это ... ?',
    variants: ['библиотека', 'фреймворк', 'приложение'],
    correct: 0,
  },
  {
    title: 'Какой язык работает в браузере ?',
    variants: ['Java', 'C', 'Python', 'JavaScript'],
    correct: 3,
  },
  {
    title: 'Сколько параметров можно передать функции ?',
    variants: [
      'Ровно столько, сколько указано в определении функции',
      'Сколько указано в определении функции или меньше',
      'Сколько указано в определении функции или больше',
      'Любое количество',
    ],
    correct: 3,
  },
  {
    title: 'Как получить HTML-содержимое DOM-элемента elem?',
    variants: ['elem.html', 'elem.innerHTML', 'elem.content'],
    correct: 1,
  },
  {
    title: 'Можно ли инициировать DOM-событие из javascript?',
    variants: ['Да, можно', 'Нет, нельзя.'],
    correct: 0,
  },
  {
    title: 'Компонент в React - это ... ',
    variants: ['часть приложения или страницы', 'приложение'],
    correct: 0,
  },
  {
    title: 'VUE - это ... ?',
    variants: ['библиотека', 'фреймворк', 'приложение'],
    correct: 1,
  },
  {
    title: 'Что такое JSX?',
    variants: [
      'Это тот же HTML, но с возможностью выполнять JS-код',
      'Это простой HTML',
      'Это функция',
    ],
    correct: 0,
  },
  {
    title: 'В какой версии React появились хуки?',
    variants: ['16.8.0', '17.0.0', '18.0.0'],
    correct: 0,
  },
];
